import script from "./DashboardPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardPage.vue?vue&type=script&setup=true&lang=js"

import "./DashboardPage.vue?vue&type=style&index=0&id=146bb538&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-146bb538"]])

export default __exports__